class CompareProduct {
  constructor() {
    this.storageKey = 'm-compare-products';
    this.products = [];
    this.productNodes = {};

    this.pageTemplate = 'page.product-compare';
    this.addedClass = 'added-to-compare';
    this.selectors = {
      container: '.m-compare-page-content__wrapper',
      noProducts: '.m-compare-no-products',
      wrapper: '.m-compare-card',
      item: '.m-product-card',
      compareButton: '.m-compare-button',
      compareText: '.m-compare-button-text',
      removeButton: '.m-compare-remove-button',
      count: '.m-compare-count'
    };

    try {
      const stored = localStorage.getItem(this.storageKey);
      this.products = stored ? Array.from(new Set(JSON.parse(stored))) : [];
    } catch (e) {
      this.products = [];
    }

    const hasContainer = !!document.querySelector(this.selectors.container);
    const isPath = window.location.pathname.indexOf('/pages/product-compare') !== -1;
    const isMinimog = window.MinimogSettings && window.MinimogSettings.template === this.pageTemplate;
    this.isComparePage = hasContainer || isPath || isMinimog;

    this.init();
  }

  init = () => {
    if (this.isComparePage) {
      this.renderComparePage();
      this.addEventToRemoveButtons();
    }
    this.setCompareButtonsState();
    this.addEventToCompareButtons();
    this.updateCompareCount();
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products));
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.products));
    } catch (e) {}
  }

  addToCompare(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle);
      this.saveToStorage();
    }
  }

  removeFromCompare(handle) {
    this.products = this.products.filter(hdl => hdl !== handle);
    this.saveToStorage();
  }

  setCompareButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.compareButton);
    buttons.forEach(btn => {
      const prodHandle = btn && btn.dataset.productHandle;
      if (prodHandle && this.products.indexOf(prodHandle) >= 0) {
        btn.classList.add(this.addedClass);
        btn.setAttribute('aria-label', 'Remove from compare');
        btn.setAttribute('title', 'Remove from compare');
        const compareText = btn.querySelector(this.selectors.compareText);
        if (compareText && compareText.dataset.revertText && compareText.textContent !== compareText.dataset.revertText) {
          const temp = compareText.dataset.revertText;
          compareText.dataset.revertText = compareText.textContent;
          compareText.textContent = temp;
        }
      } else if (btn) {
        btn.classList.remove(this.addedClass);
        btn.setAttribute('aria-label', 'Add to compare');
        btn.setAttribute('title', 'Add to compare');
      }
    });
  }

  updateCompareCount = () => {
    const size = this.products.length;
    const countElems = document.querySelectorAll(this.selectors.count);
    countElems.forEach(elem => {
      elem.textContent = size;
      elem.classList.remove('m:hidden');
    });
  }

  addEventToCompareButtons = () => {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(this.selectors.compareButton);
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const productHandle = btn.dataset.productHandle;
      if (productHandle) {
        const isCurrentlyAdded = btn.classList.contains(this.addedClass);
        const shouldAdd = !isCurrentlyAdded;

        this.toggleButtonState(btn, shouldAdd);
        this.updateCompareCount();

        document.querySelectorAll(this.selectors.compareButton).forEach(btnItem => {
          if (btnItem && btnItem.dataset.productHandle === productHandle && btnItem !== btn) {
            this.toggleButtonState(btnItem, shouldAdd);
          }
        });
      }
    });
  }

  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle;
    const compareText = btn && btn.querySelector(this.selectors.compareText);

    if (active) {
      this.addToCompare(productHandle);
      btn.classList.add(this.addedClass);
      btn.setAttribute('aria-label', 'Remove from compare');
      btn.setAttribute('title', 'Remove from compare');
    } else {
      this.removeFromCompare(productHandle);
      btn.classList.remove(this.addedClass);
      btn.setAttribute('aria-label', 'Add to compare');
      btn.setAttribute('title', 'Add to compare');
    }

    if (compareText) {
      const temp = compareText.dataset.revertText;
      if (temp) {
        compareText.dataset.revertText = compareText.textContent;
        compareText.textContent = temp;
      }
    }
  }

  addEventToRemoveButtons = () => {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(this.selectors.removeButton);
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const prod = btn.closest(this.selectors.wrapper);
      if (prod) prod.remove();

      const productHandle = btn.dataset.productHandle;
      if (productHandle) {
        this.removeFromCompare(productHandle);
        this.updateCompareCount();

        document.querySelectorAll(this.selectors.compareButton).forEach(cmpBtn => {
          if (cmpBtn && cmpBtn.dataset.productHandle === productHandle) {
            this.toggleButtonState(cmpBtn, false);
          }
        });

        if (!this.products.length) {
          this.showNoProductsMessage();
        }
      }
    });
  }

  renderComparePage = async () => {
    const container = document.querySelector(this.selectors.container);
    if (!container) return;

    let noItemAvailable = true;

    if (this.products.length) {
      const fetchHtml = async (url) => {
        if (typeof window.fetchCache === 'function') {
          return await window.fetchCache(url);
        }
        const res = await fetch(url);
        return await res.text();
      };

      const promises = this.products.map(async (hdl) => {
        try {
          const prodHTML = await fetchHtml(`/products/${hdl}?view=compare`);
          const item = document.createElement('div');
          item.classList.add('m:hidden', 'm:column', 'm-compare-card');
          item.innerHTML = prodHTML;
          if (item.querySelector(this.selectors.item)) {
            noItemAvailable = false;
            this.productNodes[hdl] = item;
          }
        } catch (err) {
          console.error('Error fetching compare product:', hdl, err);
        }
      });

      await Promise.all(promises);

      // Render in order
      this.products.forEach(hdl => {
        const prodNode = this.productNodes[hdl];
        if (prodNode) {
          container.appendChild(prodNode);
          prodNode.classList.remove('m:hidden');
        }
      });
    }

    if (noItemAvailable) {
      this.showNoProductsMessage();
    } else {
      const noProducts = document.querySelector(this.selectors.noProducts);
      if (noProducts) noProducts.classList.add('m:hidden');
      container.classList.remove('m:hidden');
      container.classList.add('is-visible');
    }
  }

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container);
    const noProducts = document.querySelector(this.selectors.noProducts);

    if (container) container.classList.add('m:hidden');
    if (noProducts) noProducts.classList.remove('m:hidden');
  }
}

function initCompare() {
  if (!window.MinimogTheme) window.MinimogTheme = {};
  window.MinimogTheme.CompareProduct = new CompareProduct();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCompare);
} else {
  initCompare();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    if (window.MinimogTheme && window.MinimogTheme.CompareProduct) {
      window.MinimogTheme.CompareProduct.setCompareButtonsState();
      window.MinimogTheme.CompareProduct.updateCompareCount();
    }
  });
}

